import { Loader } from '@crehana/ui';
import Loadable from '@crehana/web/Loadable';

const LazyARCORequest = () => (
  <Loadable
    Loader={
      <div className="w-full h-screen flex justify-center py-24">
        <Loader />
      </div>
    }
    module={() =>
      import(/* webpackChunkName: "legal-arco-request" */ './ARCORequest')
    }
  />
);

export default LazyARCORequest;
